import HTTP from '@/lib/api/Http';
import { AxiosError } from 'axios';
import { SuccessResponse } from './methods.types';

type ReturnType<T> =
   [error: null, response: SuccessResponse<T>] | [error: AxiosError<{ message: string }>, response: null];

async function trycatch<T>(fn: () => Promise<{ data: SuccessResponse<T> }>): Promise<ReturnType<T>> {
   try {
      const response = await fn();
      return [null, response.data];
   } catch (error) {
      if (error instanceof AxiosError) {
         return [error, null];
      }
      return [new AxiosError('An unknown error occurred'), null];
   }
}

export function GET<T, R>(url: string, params?: T) {
   return trycatch<R>(() => HTTP.get<SuccessResponse<R>>(url, { params }));
}

export function POST<T, R>(url: string, data: T) {
   return trycatch<R>(() => HTTP.post<SuccessResponse<R>>(url, data, { timeout: 0 }));
}

export function PATCH<T, R>(url: string, data?: T) {
   return trycatch<R>(() => HTTP.patch<SuccessResponse<R>>(url, data, { timeout: 0 }));
}
export function PUT<T, R>(url: string, data: T) {
   return trycatch<R>(() => HTTP.put<SuccessResponse<R>>(url, data, { timeout: 0 }));
}

export function DELETE<T, R>(url: string, data?: T) {
   return trycatch<R>(() => HTTP.delete<SuccessResponse<R>>(url, { data }));
}
